import React, { Component } from 'react';
import PropTypes from 'prop-types';
import request from 'axios';
import Spinner from './Spinner';
import NumberFormat from 'react-number-format';

class DistrictDetails extends Component {
   constructor(props){
      super(props);
      this.state={
         dataToRender:null,
         errorMsg: null
      }
   }
   componentWillReceiveProps(newProps){
      if(newProps.shapeId && newProps.shapeId !== this.props.shapeId){
         this.setState({dataToRender:null, errorMsg:null}); // clear data rendered
         const zoomLevel = newProps.zoomLevel-1;
         const mapType = this.props.mapsToLoad[zoomLevel]
         this.renderResults(newProps.shapeId, newProps.branch, mapType)
      }
   }
   renderResults(shapeId, branch, type){
      if(!this.props.results.data[branch][type]) return;
      const dataToShow = this.props.results.data[branch][type];
      if(dataToShow && dataToShow[shapeId]){
         // raw data loaded and shape results present
         const dataToRender = dataToShow[shapeId];
         this.setState({dataToRender, errorMsg: null})
      }else{
         // raw data loaded but shape results are missing
         this.setState({
            dataToRender: null,
            errorMsg : 'Riprova in seguito'
         })
      }
   }
   formatDate(date){
      var d = date+''; // convert number to string
      var Y = d.slice(0,4);
      var M = d.slice(4,6);
      var D = d.slice(6,8);
      var h = d.slice(8,10);
      var s = d.slice(10,12);
      return `${D}/${M}/${Y} ${h}:${s}`
   }
   ucwords(text) {
      var str = text.toLowerCase();
      return str.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g,
         function(s){
           return s.toUpperCase();
       });
   }

   render() {
      if(!this.props.visible) return '';
      return (
         <div className="district-details">
            <div className="district-header edited-header-europee">
               <h3>{this.props.label}</h3>
            </div>
            <div className="district-content">
            {this.state.dataToRender &&
               <div className="detailsContent">
                  {this.state.dataToRender.liste.map((el, index)=>{
                     const listConfig = this.context.lists[el.lista.slug];
                     // merge list config + actual results
                     const list = {...listConfig, ...el};
                     let picture = list.type==='lista' ? this.props.logoPath+list.lista.logo : '';
                     return(
                        <table cellPadding="0" cellSpacing="0" key={list.slug+index} style={{backgroundColor: (index % 2 !== 0) ? '#f9f9f9' : '#fff'}}>
                           <tbody>
                           <tr className="candidate">
                              <td width="1%" className="list-logo">
                                 <div className="logo-wrapper" style={
                                    {'background-color':`${list.color}`, 
                                    'background-image': `url(${picture})`}}></div>
                              </td>
                              <td>
                              <small><strong>
                              {list.label ? list.label : this.ucwords(list.lista.name) }
                              </strong></small>
                               </td>
                              <td width="1%" className="percent"><strong>
                              
                              <NumberFormat value={list.percentuale} decimalSeparator={','} displayType={'text'} />
                              %</strong></td>
                              <td width="1%" className="votes">
                              <NumberFormat value={list.voti} decimalSeparator={','} thousandSeparator={'.'} displayType={'text'} />
                              </td>
                           </tr>
                           </tbody>
                        </table>
                     )
                  })}
                  
               </div>
            }
            {this.state.errorMsg &&
               <div className="errorMsg">
                  <p><strong>Nessun dato disponibile</strong></p>
                  <small>{this.state.errorMsg}</small>
               </div>
            }
            </div>
            <div className="district-footer">
            {(this.state.dataToRender && typeof this.state.dataToRender.aggiornamento == "number" ) &&
               <div className="footer">Ultimo aggiornamento: {this.formatDate(this.state.dataToRender.aggiornamento)}</div>
            }
            </div>
         </div>
      );
   }
}
DistrictDetails.contextTypes = {
   lists: PropTypes.object
};
export default DistrictDetails;



// WEBPACK FOOTER //
// ./src/components/DistrictDetails.js